/**
 * Return a mapper that processes the "editable" field of
 * each column in a column definition depending on the
 * tenant profile's flags and a set of instructions.
 *
 * @param {Map<string, string>} flagMap determines which field
 *  is editable based on which flag
 * @returns {function(*): *&{editable: *}}
 */
const featureFlagColumnMapper = (flagMap) => {
  return (columnDef) => ({
    ...columnDef,
    editable: columnDef.editable
      ? flagMap.has(columnDef.accessorKey)
        ? flagMap.get(columnDef.accessorKey)
        : columnDef.editable
      : columnDef.editable,
  });
};

export default featureFlagColumnMapper;
